import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const ButtonsContainer = styled(Box)`
  display: flex;
  grid-gap: 8px;
  @media (max-width: 280px) {
    flex-wrap: wrap;
    margin-left: 1.5rem;
  }
`;
